// extracted by mini-css-extract-plugin
export default {"container":"NfDeivGyefM4dfKrwSpP","label":"OD_zqk9wzLyKOPxMZdzv","termsContainer":"jbEzZ9WkD3NzfgrtzbmW","pulse":"LmmGG9hY56JKo8vuq_02"};